import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { LyDialog } from '@alyle/ui/dialog';
import { ImgCropperEvent } from '@alyle/ui/image-cropper';

import { LyTheme2 } from '@alyle/ui';

const STYLES = ({
  slider: {
    display: 'block',
    padding: '16px'
  }
});

import { ModalImgComponent } from "./modal-img/modal-img.component";

@Component({
  selector: 'app-pruebas',
  templateUrl: './pruebas.component.html',
  styleUrls: ['./pruebas.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PruebasComponent implements OnInit {

  cropped?: string;
  readonly classes = this.theme.addStyleSheet(STYLES);
  constructor(
    private _dialog: LyDialog,
    private _cd: ChangeDetectorRef,
    private theme: LyTheme2
  ) { }

  openCropperDialog(event: Event) {
    this.cropped = null!;
    this._dialog.open<ModalImgComponent, Event>(ModalImgComponent, {
      data: event,
      width: 320,
      disableClose: true
    }).afterClosed.subscribe((result?: ImgCropperEvent) => {
      if (result) {
        this.cropped = result.dataURL;
        this._cd.markForCheck();
      }
    });
  }

  ngOnInit(): void {
  }

}
